<div class="relative overflow-x-clip lg:overflow-visible">
	<!-- Header -->
	<uc-main-header
		[heading]="headerData().title"
		[description]="headerData().description"
		backgroundStyle="bg-uni-search"
		textColor="text-white"
		descriptionColor="text-white"
	>
		<uc-search-bar-with-study-level
			class="block mt-8"
			placeholder="Search Universities"
			[selectedProduct]="product()"
			[searchValue]="searchTerm()"
			[showClearingInDropdown]="false"
			(navigate)="onSearch($event)"
		/>
	</uc-main-header>

	<!-- Dark Overlay -->
	<uc-filter-dark-overlay
		[showOverlay]="filterTogglerSrv.displayFilter"
		(click)="filterTogglerSrv.toggle(false)"
	/>

	@if (store.error() && !store.isLoading()) {
		<uc-error-handler />
	} @else {
		<div class="container py-12" id="university-search-container">
			@if (store.universities() === null && store.isLoading()) {
				<uc-universities-skeleton />
			} @else {
				<div class="flex justify-between w-full">
					<!-- Filter -->
					<uc-universities-filter
						class="flex-shrink-0 block lg:flex course-search-filter"
						[ngClass]="{
							open: filterTogglerSrv.displayFilter,
						}"
						[clearingEnabled]="clearingEnabled"
						[product]="product()"
						(closeFilter)="filterTogglerSrv.toggle(false)"
					/>

					<main class="w-full">
						@if (!store.isLoading() || store.isLoadingPagination()) {
							<uc-filter-sort-widget
								[total]="store.universities()?.total ?? 0"
								[totalPills]="store.pills().length || 0"
								[text]="universitiesFound()"
								[studyLevel]="product()"
								(toggleFilter)="filterTogglerSrv.toggle(true)"
							/>
							<uc-applied-filters-bar />
						}

						<uc-universities-list [product]="product()" />
					</main>
				</div>
			}
		</div>
	}
</div>
